module.exports = __webpack_public_path__ + "static/media/chevron-down.e1ba3e1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/chevron-down.svg
// module id = 589
// module chunks = 0